import { Component, OnInit, Inject } from '@angular/core';
import { ToastService } from '@app/shared/services/toast.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { UserType } from '@app/shared/enums/user-type.enums';
import { ChangePassWordService } from '@app/shared/services/change-password.service';
import { Messages } from '@app/shared/enums/messages.enums';
import { ChangePassWord } from '@app/shared/models/change-password.model';

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.scss']
})
export class ChangePasswordModalComponent implements OnInit {
  changePassWordForm: FormGroup;

  constructor(
    private toastService: ToastService,
    private changePassWordService: ChangePassWordService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ChangePasswordModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { ID: number, userType: UserType },
  ) { }

  ngOnInit() {
    this.changePassWordForm = this.fb.group({
      ID: [this.data.ID],
      userType: [this.data.userType],
      newPassword: [null, Validators.required],
      confirmPassword: [null, Validators.required],
    }, {
        validator: ChangePassWordService.MatchPassword
      });
  }

  close(): void {
    this.dialogRef.close();
  }

  changePassword(): void {
    const cp: ChangePassWord = new ChangePassWord(this.changePassWordForm.controls.ID.value, this.changePassWordForm.controls.userType.value, this.changePassWordForm.controls.newPassword.value)
    this.changePassWordService.ChangePasswordDeliveryOrWebapp(cp).subscribe((response) => {
      this.toastService.info(response);
      this.close();
    }, (error) => { this.toastService.error(error ? error : Messages.defaultError); });
  }
}
